<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-transparent">
            Configuration File &nbsp Last upload was on
            {{ lastUpdate.last_update }}
          </div>
          <div class="card-body">
            <span class="float-left">
              <button
                @click="
                  $downloadFile({
                    name: lastUpdate.name,
                    fileId: 4,
                    url: `${BASE_URL}api/files/download/`,
                  })
                "
                class="btn btn-outline-primary"
              >
                <i class="fa fa-download pr-1"></i>
                Download Risk Factor file
              </button>
            </span>
            <span class="float-right">
              <file-dragdrop
                title="Select a document file to upload"
                label="Upload"
                @upload="
                  (files) =>
                    $uploadFile({
                      fileId: 4,
                      file: files[0],
                    })
                "
              >
              </file-dragdrop>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-transparent">
            Select risk factor configuration
          </div>
          <div class="card-body">
            <select
              class="selectpicker form-control custom"
              style="border-radius: 6px"
              @change="onChange"
              v-model="selected"
            >
              <option v-for="rf in rfs">
                {{ mapDict[rf] }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-transparent">
            Risk Factor Threshold configuration
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <table
                  class="table table-sm table-hover table-striped"
                  v-if="init != 'ncj'"
                >
                  <thead>
                    <tr>
                      <th>Country</th>
                      <th>Condition</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(condition, country) in table">
                      <td style="width: 80px">
                        {{ country }}
                      </td>
                      <td>
                        {{ condition }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table table-sm table-hover table-striped" v-else>
                  <thead>
                    <tr>
                      <th>Country</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="condition in table">
                      <td style="width: 80px">
                        {{ condition }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/constants/config";

export default {
  name: "RiskFactors",
  data() {
    return {
      BASE_URL,
      apiEndpointBase: `${BASE_URL}api/overview`,
      data: null,
      init: "",
      lastUpdate: {},
      selected: "convoluted product description risk",
      table: [],
      tableData: [],
      reverseDict: {},
      mapDict: {
        corr_nocft: "no call for tenders publication risk",
        corr_proc: "high risk procedure type",
        corr_subm_p: "short advertisement period risk",
        corr_decp: "short decision period risk",
        corr_ecrit: "convoluted eligibility criteria risk",
        corr_descrl: "convoluted product description risk",
        ncj: "Countries labelled non-cooperative jurisdiction",
      },
      rfs: null,
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.reverseDict = Object.fromEntries(
        Object.entries(this.mapDict).map(([key, value]) => [value, key])
      );
      this.tableData = (
        await this.$request({ url: `${this.apiEndpointBase}/config` })
      ).data;
      this.rfs = Object.keys(this.tableData);
      this.init = this.reverseDict[this.selected];
      this.table = this.tableData[this.init][0];
      this.lastUpdate = (
        await this.$request({ url: `${this.apiEndpointBase}/risk/last_update` })
      ).data;
    },
    onChange() {
      this.init = this.reverseDict[this.selected];
      this.table = this.tableData[this.init][0];
      if (this.init === "ncj") {
        this.table = this.table.split(" ");
      }
    },
  },
};
</script>

<style scoped>
table {
  border-radius: 3px;
  background-color: #fff;
  width: 75%;
  text-align: center;
}

th {
  background-color: #3a75b6;
  text-align: center;
  color: #fefefe;
  cursor: pointer;
  user-select: none;
  border: 1px solid #3a75b6;
}

td {
  border: 1px solid #3a75b6;
}
</style>
